import * as devConfig from "../../app/configs/devConfig";
import { ClientRequest } from "../clientRequests/clientRequests.types";
import { getPortalSession } from "./portalSession";

/** Uploads one file for one item of a request list, reporting progress (0-100). Answers the updated list. */
export const uploadRequestFile = (
  requestId: string,
  itemId: string,
  file: File,
  onProgress: (percent: number) => void,
): Promise<ClientRequest> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      `${devConfig.getServerBaseUrlForEnv()}/api/portal/requests/${requestId}/items/${itemId}/files`,
    );
    const session = getPortalSession();
    if (session)
      xhr.setRequestHeader("Authorization", `Bearer ${session.token}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable)
        onProgress(Math.min(99, Math.round((e.loaded / e.total) * 100)));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(100);
        try {
          resolve(JSON.parse(xhr.responseText) as ClientRequest);
        } catch {
          reject(
            new Error(
              "Uploaded, but the list couldn't be refreshed. Reload the page.",
            ),
          );
        }
      } else if (xhr.status === 401) {
        reject(
          Object.assign(new Error("Please sign in again."), { status: 401 }),
        );
      } else if (xhr.status === 413) {
        reject(new Error(`"${file.name}" is too large to upload.`));
      } else {
        const text = (xhr.responseText || "").trim();
        reject(
          new Error(
            text && !text.startsWith("<") && text.length < 300
              ? text
              : `"${file.name}" couldn't be uploaded. Please try again.`,
          ),
        );
      }
    };
    xhr.onerror = () =>
      reject(
        new Error(
          "We can't reach the portal right now. Check your connection and try again.",
        ),
      );
    const body = new FormData();
    body.append("file", file);
    xhr.send(body);
  });
